import { EnumSpreadshirtProduct, EnumPodMarketplace } from '../../../../../../constants/research';
import { ISearchLinkConfig, ISearchParameterConfig } from '../../../../data/search-links.interface';
import { SPREADSHIRT_SORTING_LIST } from '../spreadshirt-search.data';


/**------------------------------------------------------
 * Product Configurations
 */
const SPREADSHIRT_PRODUCT_LIST_ES: ISearchParameterConfig<EnumSpreadshirtProduct>[] = [
	{
		code		: EnumSpreadshirtProduct.All,
		name		: 'All Products',
		placeholders: { '[PRODUCT]': '' }
	},
	{
		code		: EnumSpreadshirtProduct.Shirt,
		name		: 'T-Shirt',
		placeholders: { '[PRODUCT]': 'ropa/camisetas' } // cspell:disable-line
	},
	{
		code		: EnumSpreadshirtProduct.VNeck,
		name		: 'V-Neck',
		placeholders: { '[PRODUCT]': 'ropa/camisetas' }, // cspell:disable-line
		parameters	: { 'neckline' : 'N1' }
	},
	{
		code		: EnumSpreadshirtProduct.Hoodie,
		name		: 'Hoodie',
		placeholders: { '[PRODUCT]': 'ropa/sudaderas/sudaderas-con-capucha' } // cspell:disable-line
	},
	{
		code		: EnumSpreadshirtProduct.TankTop,
		name		: 'Tank Top',
		placeholders: { '[PRODUCT]': 'ropa/camisetas-de-tirantes' } // cspell:disable-line
	},
	{
		code		: EnumSpreadshirtProduct.LongSleeve,
		name		: 'Long Sleeve',
		placeholders: { '[PRODUCT]': 'ropa/camisas-de-manga-larga' } // cspell:disable-line
	},
	{
		code		: EnumSpreadshirtProduct.Sweatshirt,
		name		: 'Sweatshirt',
		placeholders: { '[PRODUCT]': 'ropa/sudaderas/sudaderas-sin-capucha' } // cspell:disable-line
	}
];


/**------------------------------------------------------
 * Spreadshirt Configuration
 */
export const SPREADSHIRT_CONFIG_ES: ISearchLinkConfig = {
	marketplace		: EnumPodMarketplace.ES,
	websiteUrl		: {
		home		: 'https://www.spreadshirt.es/',
		login		: 'https://www.spreadshirt.es/login',
		search		: 'https://www.spreadshirt.es/shop/[PRODUCT]/[SEARCH]/?page=[PAGE]'
	},
	pageLimit		: 167,
	sortings		: SPREADSHIRT_SORTING_LIST,
	products		: SPREADSHIRT_PRODUCT_LIST_ES,
	category	    : [],
	options 		: {
		emptySearch : true
	}
};
